import * as React from "react";
import Head from "../components/Head";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Gallery from "../components/Gallery";
import Recruit from "../components/Recruit";
import News from "../components/News";
import FirstView from "../components/FirstView";
import TopService from "../components/TopService";
import TextSection from "../components/TextSection";
import TopPageSecondView from "../components/TopPageSecondView";
import Store from "../components/Store";


const IndexPage = () => {
  return (
    <>
      <Head imagePath="https://forustyle-985bb.web.app/ogp-top.jpg" />
      <Header isTop />
      <FirstView />
      <TextSection bgcolor="#A7ADAB" />
      <TopPageSecondView />
      <div id="store"></div>
      <Store />
      <TopService />
      <News />
      <Gallery />
      <Recruit />
      <Footer />
    </>
  );
};

export default IndexPage;
